import { Disclosure as BasicDisclosure, Transition } from '@headlessui/react';
import { analytics } from "../../helpers/analytics";
import { useContext } from 'react';
import { UserContext } from '../../context/userContext';

type Props = {
  title: string;
  children: React.ReactChild;
};

const Disclosure = ({ title, children }: Props) => {
  const { user } = useContext(UserContext);
  const { hasPremium = false } = user || {};

  const handleButtonClick = () => {
    analytics.track('How It works - Tapped', { premium: hasPremium, section: title });
  };

  return (
    <BasicDisclosure>
      {({ open }) => (
        <>
          <BasicDisclosure.Button
            className='flex justify-between w-full select-none'
            onClick={handleButtonClick}
            style={{ outline: 'none' }}
          >
            <span className='text-2xl leading-2xl font-bold mb-4 text-left sm:text-xl sm:leading-xl'>{title}</span>
            <div className='h-[27px] w-[27px] relative shrink-0'>
              <div className='h-[3px] w-[13px] absolute -translate-x-2/4 -translate-y-2/4 left-2/4 top-2/4 bg-black' />
              <div
                className={`w-[3px] h-[13px] 
            absolute -translate-x-2/4 -translate-y-2/4 
            left-2/4 top-2/4 bg-black transition-transform
            ${open ? 'rotate-90' : 'rotate-0'}
            `}
              />
            </div>
          </BasicDisclosure.Button>

          <Transition
            enter='transition duration-100 ease-out'
            enterFrom='transform scale-95 opacity-0'
            enterTo='transform scale-100 opacity-100'
            leave='transition duration-75 ease-out'
            leaveFrom='transform scale-100 opacity-100'
            leaveTo='transform scale-95 opacity-0'
            className='w-full'
          >
            <BasicDisclosure.Panel className='w-full'>{children}</BasicDisclosure.Panel>
          </Transition>
        </>
      )}
    </BasicDisclosure>
  );
};

export { Disclosure };
